export default __webpack_public_path__ + "static/img4-5da1110190f338734659a23ca8bb63c4.png";